package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class CoachWidgetResponse(

    @SerialName("averages")
    val averages: ClubAverages = ClubAverages(),

    @SerialName("recentTrend")
    val recentTrend: RecentTrend = RecentTrend(),

    val totalSessions: Long = 0,
)

@Serializable
data class GetWidgetCoachProfilePayload(
    @SerialName("userID")
    val userId: String,
    val organization: String,
    @SerialName("seasonID")
    val seasonId: String,
)